import { faSpinner } from '@fortawesome//pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, lighten, makeStyles, Theme, Typography, useTheme } from '@material-ui/core';
import { NotInterested } from '@material-ui/icons';
import clsx from 'classnames';
import React from 'react';
import { ContentActionGq } from '../../../../../graphql/projects/models/ContentActionGq';

export interface TaskActionProps {
  action: ContentActionGq;
  table?: boolean;
  size: 'medium' | 'small';
}

const useClasses = makeStyles((theme: Theme) => ({
  typography: {
    ...theme.typography.button,
    color: lighten(theme.palette.text.secondary, 0),
  },
  hint: {
    ...theme.typography.button,
    color: lighten(theme.palette.text.secondary, 0.3),
  },
  sizeSmall: {
    fontSize: '12px',
  },
}));

const Action: React.FC<{ action: ContentActionGq; size: 'medium' | 'small' }> = ({
  action,
  size,
}) => {
  const theme = useTheme();
  const classes = useClasses();
  return (
    <>
      {action === ContentActionGq.OK && (
        <Typography
          variant={'button'}
          className={clsx({ [classes.typography]: true, [classes.sizeSmall]: size === 'small' })}
        >
          OK
        </Typography>
      )}
      {action === ContentActionGq.OPTIMIZE && (
        <Typography
          variant={'button'}
          className={clsx({ [classes.typography]: true, [classes.sizeSmall]: size === 'small' })}
        >
          OPTIMIZE
        </Typography>
      )}
      {action === ContentActionGq.CREATE && (
        <Typography
          variant={'button'}
          className={clsx({ [classes.hint]: true, [classes.sizeSmall]: size === 'small' })}
        >
          CREATE
        </Typography>
      )}
      {action === ContentActionGq.MISSING && (
        <Typography
          variant={'button'}
          className={clsx({ [classes.typography]: true, [classes.sizeSmall]: size === 'small' })}
        >
          MISSING
        </Typography>
      )}
      {action === ContentActionGq.NO_ACTION && <NotInterested fontSize={size} color={'disabled'} />}
      {action === ContentActionGq.LOADING && (
        <FontAwesomeIcon icon={faSpinner} color={theme.palette.grey[700]} />
      )}
    </>
  );
};

export const TaskAction: React.FC<TaskActionProps> = React.memo(({ action, table, size }) => {
  return table ? (
    <Action action={action} size={size} />
  ) : (
    <Box pl={1}>
      <Action action={action} size={size} />
    </Box>
  );
});

export default TaskAction;
